import React, { useEffect, useRef, useState } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, Divider, FormControl, FormControlLabel, FormHelperText, IconButton, InputLabel, ListItemText, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import FileUploader from '../Common/FileUploader';
import { CloseRounded } from '@mui/icons-material';
import { fetchDomains, importDomain } from '../../store/domainSlice';
import { fetchIndustries, fetchIndustryList } from '../../store/industrySlice';

export default function ImportDomain({ open, setOpen }) {
    const dispatch = useDispatch();
    const [fileType, setFileType] = useState(null);
    const [filePreview, setFilePreview] = useState(null);
    const industries = useSelector((state) => state.industryReducer.industryList)
    const validationSchema = Yup.object({
        industry_id: Yup.string().required("Client is required"),
        media: Yup.mixed()
    });

    const formik = useFormik({
        initialValues: {
            landing_page: [],
            industry_id: "",
            media: null,
            is_affiliate: false,

        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("values", values)
            const formData = new FormData();
            formData.append('file', values.media);
            formData.append('industry_id', values.industry_id);
            formData.append('is_affiliate', values.is_affiliate);
            dispatch(importDomain(formData)).then((res) => {
                dispatch(fetchDomains())
            })
            setOpen(false);

        },
    });

    useEffect(() => {
        formik.resetForm()
        setFilePreview(null)
    }, [open])

    // useEffect(() => {
    //     dispatch(fetchIndustryList())
    // }, [])


    return (
        <Box className="p-3 position-relative h-100">
            <form onSubmit={formik.handleSubmit} >
                <Box className="d-flex justify-content-between">
                    <Typography variant="h6" gutterBottom>
                        Import Domains
                    </Typography>
                </Box>
                <Divider />
                <div className='role-form-scroller'>
                    <FormControl fullWidth className='mt-3 min-with-select'
                        error={formik.touched.industry_id && Boolean(formik.errors.industry_id)}
                        required
                    >
                        <InputLabel id="industry_id">Industry</InputLabel>
                        <Select
                            fullWidth
                            labelId="industry_id"
                            id="industry_id"
                            name='industry_id'
                            label="Industry"
                            value={formik.values?.industry_id}
                            onChange={formik.handleChange}
                            MenuProps={{
                                PaperProps: {
                                    className: "mui-select-menu",
                                }
                            }}
                            endAdornment={
                                formik.values.industry_id ? (
                                    <IconButton
                                        size="small"
                                        className='mr-4'
                                        onClick={() => formik.setFieldValue('industry_id', '')}
                                        onMouseDown={(event) => event.stopPropagation()}
                                    >
                                        <CloseRounded />
                                    </IconButton>
                                ) : null
                            }
                            onBlur={formik.handleBlur}
                            error={formik.touched.industry_id && Boolean(formik.errors.industry_id)}
                            helperText={formik.touched.industry_id && formik.errors.industry_id}
                        >
                            {(!industries || industries?.length === 0) && (
                                <MenuItem disabled color="primary">
                                    No Industry found.
                                </MenuItem>
                            )}
                            {industries?.length && industries?.map((ele) => <MenuItem value={ele.id}>{ele.title}</MenuItem>)}
                        </Select>
                        {formik.touched.industry_id && formik.errors.industry_id && (
                            <FormHelperText className='text-danger'>{formik.errors.industry_id}</FormHelperText>
                        )}
                    </FormControl>

                    <FileUploader
                        name="media"
                        formik={formik} {...{ fileType, setFileType, filePreview, setFilePreview }}
                        label="Upload File (Excel/CSV)"
                        isRequired={true}
                        accept={{
                            '.xlsx': [],
                            '.csv': [],
                            '.xls': [],
                        }}
                    />
                    <Box className="d-flex item-align-center">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={formik.values.is_affiliate}
                                    onChange={(e) => {
                                        formik.setFieldValue('is_affiliate', e.target.checked);
                                    }}
                                    color="primary"
                                />
                            }
                            label="Use Affiliate Link"
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '0.875rem',
                                    color: 'primary.main',
                                },
                            }}
                        />
                    </Box>
                </div>

                <Box className="drawer-footer m-3">
                    <Button
                        type="button"
                        variant="outlined"
                        color="primary"
                        onClick={() => setOpen(false)}
                        className="mt-2 mr-2"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        className="mt-2 mr-2"
                        onClick={() => {
                        }}
                        startIcon={<SystemUpdateAltIcon color='white' />}
                        disabled={!(formik.values?.media && formik.values?.industry_id) || formik.isSubmitting}
                    >
                        Import
                    </Button>
                </Box>
            </form>
        </Box>
    );
}